"use strict";

exports.__esModule = true;
exports.getWidgetFontProps = getWidgetFontProps;
/**
 * Get font related properties for a widget.
 */
function getWidgetFontProps(_ref, target) {
  var fontFamily = _ref.fontFamily,
    fontSize = _ref.fontSize,
    fontStyle = _ref.fontStyle,
    fontWeight = _ref.fontWeight,
    textDecoration = _ref.textDecoration,
    textAlignment = _ref.textAlignment;
  if (target === void 0) {
    target = "svg";
  }
  if (target === "css") {
    return {
      fontFamily: fontFamily,
      fontSize: fontSize,
      fontStyle: fontStyle,
      fontWeight: fontWeight,
      textDecoration: textDecoration,
      textAlign: textAlignment
    };
  }
  var textAnchor;
  if (textAlignment === "left") {
    textAnchor = "start";
  } else if (textAlignment === "center") {
    textAnchor = "middle";
  } else if (textAlignment === "right") {
    textAnchor = "end";
  }
  return {
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    textDecoration: textDecoration,
    textAnchor: textAnchor
  };
}